export default {"src":"/_next/static/media/star.5543a9f2.svg","height":23,"width":24};